import View from '../atoms/view';
import { H3 } from '../atoms/text';
import { ThreeDots } from 'react-loader-spinner';
import theme from '../../theme';

type BubbleLoadingWidgetProps = {
  text?: string;
};

export const BubbleLoadingWidget = ({ text }: BubbleLoadingWidgetProps) => {
  return (
    <View extend={style}>
      <ThreeDots
        color={theme.colors.primary}
        height={50}
        width={50}
      />
      <H3>{text ?? ''}</H3>
    </View>
  );
};

const style = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
};
